import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberformat'
})
export class NumberFormat implements PipeTransform {
  transform(value: number, args?: any): any {
    return value.toString().match(/\d{3}(?=\d{2,3})|\d+/g).join("-");
  }
}


// WEBPACK FOOTER //
// ./src/app/common/pipes/number-format.pipe.ts